/**
 * UI exposure gate for the staged custom-video-protocol presentation.
 *
 * The protocol remains usable by the backend for every BYOM owner. This hook
 * only controls whether the console shows the new specialist-facing mapping
 * and missing-key treatment or the established request-pattern form.
 */

import { useAuth } from '../contexts/AuthContext'
import { isMetaEmail } from '../utils/metaEmail'

export function useCustomProtocolUiEnabled(): boolean {
  const { user, isAuthenticated } = useAuth()
  return isAuthenticated && isMetaEmail(user?.email)
}
